export default __webpack_public_path__ + "static/media/colegio.f62db881.webp";